import "bootstrap/dist/css/bootstrap.min.css";
import "./css/App.css";
import "./css/mobile.css";
import "./css/responsive.css";
import AppRoute from "./Variables/AppRoutes";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from "./pages/Layout/Header";
import Footer from "./pages/Layout/Footer";
import { Global } from "./Variables/Global";
import Util from "./Classes/Util";
import { useState } from "react";
import Cookies from "js-cookie";
import { MetadataProvider } from './Contexts/MetadataContext';
import Meta from './Components/Meta';
import PageLoader from './Components/PageLoader';
import FooterGate from './Components/FooterGate';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  const [customerDetail, setCustomerDetail] = useState({
    FirstName: "",
    LastName: "",
  });
  const [subscribe, setSubscribe] = useState(false)
  const [cartCount, setCartCount] = useState(0);
  const [wishListCount, setWishListCount] = useState(0);
  const [cartItem, setCartItem] = useState([]);
  const [wishListItem, setWishListItem] = useState([]);
  const [crossSell, setCrossSell] = useState([])
  const [upSell, setUpSell] = useState([])
  const [headerTitle, setHeaderTitle] = useState("")
  const [footerActive, setFooterActive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCustomer = (ID) => {
    const token = Cookies.get("CustomerToken");
    fetch(Global.API_URL + "Customer/GetCustomerDetails/" + ID, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((Response) => Response.json())
      .then((Result) => {
        setCustomerDetail(Result);
      });
  };

  const checkIfCustomerLoggedIn = () => {
    setIsLoading(true);
    if (localStorage.getItem("PMToken") !== null) {
      var token = Util.decrypt(localStorage.getItem("PMToken"));
      var ID = Util.decrypt(localStorage.getItem("Number"));
      fetch(Global.API_URL + "Customer/CheckCustomerLoginToken", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customerId: ID,
          customerToken: token,
        }),
      })
        .then((Response) => {
          if (Response.ok) {
            return Response.json();
          } else {
            localStorage.clear();
            checkIfCustomerLoggedIn();
          }
        })
        .then((Result) => {
          fetchCustomer(ID);
          if (localStorage.getItem("Cart")) {
            GetCartItem(Util.decrypt(localStorage.getItem("Cart")));
          }
          if (localStorage.getItem("WishList")) {
            GetWishListItem(Util.decrypt(localStorage.getItem("WishList")));
          }
        });
    } else {
      localStorage.clear()
      if (sessionStorage.getItem("Guest") === null) {
      } else {
        var GuestID = Util.decrypt(sessionStorage.getItem("Guest"));
      }
    }
    setIsLoading(false);
  };

  const GetWishListItem = async (ID) => {
    var groupId;
    if (localStorage.getItem("WishList")) {
      groupId = 4
    } else {
      groupId = 3
    }
    const offset = new Date().getTimezoneOffset();
    const token = Cookies.get("CustomerToken");
    fetch(Global.API_URL + "Wishlist/GetWishistItems/" + ID + "/" + offset + "/" + 125 + "/" + groupId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((Response) => {
        if (Response.ok) {
          return Response.json();
        }
      })
      .then((Result) => {
        setWishListCount(Result.Count);
        setWishListItem(Result.WishlistItems);
      });
  };
  const GetCartItem = async (ID) => {
    var groupId;
    if (Cookies.get("WishList")) {
      groupId = 4
    } else {
      groupId = 3
    }
    const token = Cookies.get("CustomerToken");
    const offset = new Date().getTimezoneOffset();
    fetch(Global.API_URL + "Cart/GetCartItems/" + ID + "/" + offset + "/" + groupId + "/" + 125, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((Response) => {
        if (Response.ok) {
          return Response.json();
        }
      })
      .then((Result) => {
        setCartCount(Result.Count);
        setCartItem(Result.CartItems);
      });
  };

  return (
    <HelmetProvider>
    <MetadataProvider>
    <BrowserRouter>
      <Header
        customerDetail={customerDetail}
        setCustomerDetail={setCustomerDetail}
        wishListCount={wishListCount}
        cartCount={cartCount}
        setCartCount={setCartCount}
        setWishListCount={setWishListCount}
        cartItem={cartItem}
        setCartItem={setCartItem}
        setWishListItem={setWishListItem}
        wishListItem={wishListItem}
        subscribe={subscribe}
        setSubscribe={setSubscribe}
        upSell={upSell}
        crossSell={crossSell}
        headerTitle={headerTitle}
      />
      <Meta />
      <div className="app-content">
      {
        isLoading ? (
          <PageLoader />
        ) : (
          <AppRoute
        customerDetail={customerDetail}
        setCustomerDetail={setCustomerDetail}
        wishListCount={wishListCount}
        cartCount={cartCount}
        setCartCount={setCartCount}
        setWishListCount={setWishListCount}
        cartItem={cartItem}
        setCartItem={setCartItem}
        setWishListItem={setWishListItem}
        wishListItem={wishListItem}
        subscribe={subscribe}
        setSubscribe={setSubscribe}
        upSell={upSell}
        crossSell={crossSell}
        headerTitle={headerTitle}
        setHeaderTitle={setHeaderTitle}
        footerActive={footerActive}
        setFooterActive={setFooterActive}
      />
        )
       }
      </div>
      
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <FooterGate>
      <Footer
        customerDetail={customerDetail}
        setCustomerDetail={setCustomerDetail}
        wishListCount={wishListCount}
        cartCount={cartCount}
        setCartCount={setCartCount}
        setWishListCount={setWishListCount}
        cartItem={cartItem}
        setCartItem={setCartItem}
        setWishListItem={setWishListItem}
        wishListItem={wishListItem}
        subscribe={subscribe}
        setSubscribe={setSubscribe}
        upSell={upSell}
        crossSell={crossSell}
        footerActive={footerActive}
      />
      </FooterGate>
    </BrowserRouter>
    </MetadataProvider>
    </HelmetProvider>
  );
}

export default App;
